<template>
	<div class="templateManagement">
    <el-form :model="searchForm" ref="searchForm" label-width="150px" style="padding-top: 20px">
      <el-row>
				<el-col :xl="6" :lg="8" :md="12">
          <el-form-item class="form_item" label="Document Type:" prop="fileType">
            <el-select filterable v-model="searchForm.fileType" clearable placeholder="Please select">
              <el-option v-for="item in fileTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
				</el-col>
				<el-col :xl="6" :lg="8" :md="12" style="padding: 6px 0 0 15px;">
          <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">Search</el-button>
          <el-button type="primary" size="mini" icon="el-icon-upload" @click="openUpload()" style="margin-bottom: 10px">Upload</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
      <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
      <el-table-column prop="number" label="No." align="center" width="50">
        <template slot-scope="scope">
						{{ (currentPage - 1) * pageSize + scope.$index + 1 }}
					</template>
      </el-table-column>
      <el-table-column prop="fileName" label="File Name" align="center"  min-width="450">
        <template slot-scope="scope">
          <a style="color:blue;" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="fileType" label="Document Type" align="center"  width="200">
        <template slot-scope="scope">
          {{ scope.row.fileType === 20 ? 'Management Process' : 
             scope.row.fileType === 21 ? 'Template' : 
             scope.row.fileType === 23 ? 'Explanation Document' : 
             scope.row.fileType === 22 ? 'Others' :  
             scope.row.fileType
          }}
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="Update Date" align="center" width="150">
        <template v-slot="scope">
          {{ scope.row.updateDate ? moment(scope.row.updateDate).format('YYYY-MM-DD') : ''}}
        </template>
      </el-table-column>
      <el-table-column label="Operation" align="center" width="200">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="openUpload(scope.row)">Cover</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageDiv" v-if="totalCount && totalCount > 0">
      <el-pagination
        small
        layout="total, prev, pager, next, sizes"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        @size-change="changePageSize"
        @current-change="changePage"
      >
      </el-pagination>
			</div>
		<el-dialog
			title="Upload"
			width="500px"
			:visible.sync="uploadVisible"
			:close-on-click-modal="false"
		>
			<el-form :model="uploadForm" ref="uploadForm" label-width="140px">
        <el-form-item class="form_item" label="Document Type:" prop="fileType" :rules="[{ required: true, message: 'Please select' }]">
          <el-select filterable v-model="uploadForm.fileType" clearable placeholder="Please select">
            <el-option v-for="item in fileTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
				<el-form-item label="File:" prop="file" :rules="[{ required: true, message: 'Please upload' }]">
					<el-upload
						class="upload-demo"
						:action="this.$store.state.islhurl + '/s3/upload'"
						:file-list="fileList"
						:on-change="changeFile"
						:on-remove="handleRemove"
						:on-exceed="handleExceed"
						:auto-upload="false"
						v-model="uploadForm.file"
					>
						<el-button size="small" type="primary">Upload</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeUpload()">Cancel</el-button>
				<el-button type="primary" :loading="confirmLoading" size="small" @click="confirmFile()">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import moment from 'moment';
  export default {
    name: 'templateManagement',
    created () {
      this.handleSearch();
    },
    data () {
      return {
        moment,
        searchForm: {
          fileType: '',
        },
        tableLoading: false,
				currentPage: 1,
				pageSize: 10,
        totalCount: 0,
        tableData: [],
        fileTypeList: [
          {
            name: 'Management Process',
            id: 20,
          },
          {
            name: 'Template',
            id: 21,
          },
          {
            name: 'Explanation Document',
            id: 23,
          },
          {
            name: 'Others',
            id: 22,
          }
        ],
        uploadVisible: false,
        uploadForm: {},
        fileList: [],
        confirmLoading: false,
      }
    },
    methods: {
      handleSearch(type) {
        let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					projectId: -1,
          fileType: this.searchForm.fileType,
				}
				this.tableLoading = true;
        if(type !== 'page') {
          this.currentPage = 1;
        }
				let url =`${this.$store.state.islhurl}projectFile/getListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						  this.tableData = res.data;
						  this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
      },
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch('page');
			},
      openUpload(row) {
        this.uploadVisible = true;
        if(row && row.id) {
          this.uploadForm = {
            id: row.id,
            fileType: row.fileType,
          };
        };
      },
      closeUpload() {
        this.uploadVisible = false;
        this.fileList = [];
        this.uploadForm = {};
        this.$nextTick(() => {
          this.$refs.uploadForm.clearValidate();
        });
      },
			changeFile(file, fileList) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
        } else {
          this.fileList = fileList;
          this.uploadForm = {
            ...this.uploadForm,
            file: fileList
          };
        }
      },
			handleRemove(file) {
				const index = this.fileList.findIndex((item) => item.uid === file.uid);
        this.fileList.splice(index, 1);
				this.uploadForm = {
					...this.uploadForm,
					file: this.fileList
				};
			},
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
      downloadFile(row) {
        if(row.fileAliasName && row.fileName) {
          window.open(`${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(row.fileAliasName)}&fileName=${encodeURIComponent(row.fileName)}`);
        }
      },
      handleDelete(row) {
        this.$confirm("Are you sure to delete the file", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          let url = `${this.$store.state.islhurl}projectFile/deleteFileById?idParam=${row.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`
          this._post(url).then(
            res =>{
              if(res.code === 200) {
                this.handleSearch();
                this.$Message.success('Delete Successful' )
              } else {
                this.$message({
                  type:'error',
                  message: res
                });
              }
            }
          )
        }).catch(() => {
        });
      },
      confirmFile() {
        this.$refs.uploadForm.validate((valid) => {
					if (valid) {
            let fd = new FormData();
            fd.append('file', this.fileList[0].raw);
            let params = {
              fileType: this.uploadForm.fileType,
              projectId: -1,
              islhToken: sessionStorage.getItem("islhtoken"),
            }
            let url = `${this.$store.state.islhurl}s3/upload`
            if(this.uploadForm.id) {
              url =`${this.$store.state.islhurl}projectFile/editAndReplace`;
              params.id = this.uploadForm.id;
              params.projectId = -1;
            }
						fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
            this.confirmLoading = true;
						this._post(url, fd).then(
							res => {
                this.confirmLoading = false;
								if(res.code === 200) {
									this.$Message.success('Upload successful!' );
                  this.handleSearch()
									this.closeUpload()
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
      },
		},
  }
</script>
<style lang="less" scoped>
.templateManagement {
	/deep/.el-table .cell {
		word-break: break-word;
	}
	.el-form {
		.el-form-item {
			margin-bottom: 20px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/commonDocuments/index.vue